import $ from '@sparta.global.vendors/jquery';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import workflowUtility from '@sparta.digital-mortgage-application.utilities/workflow-utility/dist/es6.js';
import mloInformationUtility from '@sparta.digital-mortgage-application.utilities/mlo-information-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { link, layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template$1 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\r\n<div id=\"dmaTitleModuleContainer\"></div>\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showMLOInfo") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":37,"column":11}}})) != null ? stack1 : "")
    + "\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n      <div>\r\n        <p>"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"modal") : stack1)) != null ? lookupProperty(stack1,"heading2") : stack1), depth0))
    + "</p>\r\n        <div class=\"main-content\">\r\n          <div id=\"helpIconInsertMloInfo\"></div>\r\n        </div>\r\n     </div>\r\n\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"modal") : stack1),{"name":"with","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":6},"end":{"line":36,"column":15}}})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>\r\n\r\n          <div class=\"main-content\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"rows") : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":12},"end":{"line":24,"column":21}}})) != null ? stack1 : "")
    + "          </div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"footer") : depth0),{"name":"with","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":10},"end":{"line":33,"column":19}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <p>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0))
    + "<br>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"link") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"footer-content\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":14},"end":{"line":31,"column":23}}})) != null ? stack1 : "")
    + "            </div>\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                <span class=\"body-small roboto-regular\">"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</span><br />\r\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"help-get-a-call-back-layer\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"helpCallMeBackModal") : stack1)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"with","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":43,"column":6},"end":{"line":50,"column":15}}})) != null ? stack1 : "")
    + "    </div>\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>\r\n          <p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"paragraph") || (depth0 != null ? lookupProperty(depth0,"paragraph") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"paragraph","hash":{},"data":data,"loc":{"start":{"line":45,"column":13},"end":{"line":45,"column":28}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n        </div>\r\n        <div class=\"dme-modal-actions\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"callMeBackBtn") : depth0),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":48,"column":10},"end":{"line":48,"column":36}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"help-get-a-call-back-layer\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"mloWorksWithAssociate") : stack1)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"with","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":56,"column":6},"end":{"line":63,"column":15}}})) != null ? stack1 : "")
    + "    </div>\r\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>\r\n          <p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"paragraph") || (depth0 != null ? lookupProperty(depth0,"paragraph") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"paragraph","hash":{},"data":data,"loc":{"start":{"line":58,"column":13},"end":{"line":58,"column":28}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n        </div>\r\n        <div class=\"dme-modal-actions\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"continueAsEmployeeBtn") : depth0),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":61,"column":10},"end":{"line":61,"column":44}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"help-get-a-call-back-layer\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"mloLendingOfficerChanged") : stack1)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"with","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":69,"column":6},"end":{"line":76,"column":15}}})) != null ? stack1 : "")
    + "    </div>\r\n";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>\r\n          <p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"paragraph") || (depth0 != null ? lookupProperty(depth0,"paragraph") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"paragraph","hash":{},"data":data,"loc":{"start":{"line":71,"column":13},"end":{"line":71,"column":28}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n        </div>\r\n        <div class=\"dme-modal-actions\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"continueWithApplicationBtn") : depth0),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":74,"column":10},"end":{"line":74,"column":49}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"title-bar-help-wrapper\">\r\n\r\n  "
    + ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"helpTooltipButton") : stack1),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":3,"column":2},"end":{"line":3,"column":45}}})) != null ? stack1 : "")
    + "\r\n\r\n"
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"helpTooltip") : stack1),{"name":"layerContent","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":2},"end":{"line":39,"column":19}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"helpCallMeBackModal") : stack1),{"name":"layerContent","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":2},"end":{"line":52,"column":19}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"mloWorksWithAssociate") : stack1),{"name":"layerContent","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":54,"column":2},"end":{"line":65,"column":19}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"mloLendingOfficerChanged") : stack1),{"name":"layerContent","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":67,"column":2},"end":{"line":78,"column":19}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.digital-mortgage-application.modules/dma-title-module",
  "version": "2.0.1",
  "id": "dmaTitleModule",
  "containerID": "digitalMortgageApplicationDmaTitleModule",
  "moduleName": "digital-mortgage-application-dma-title-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "dma-title-module",
  "data": {
    "init": "dmaTitleModuleJS",
    "options": {
      "copy": "{{json copy}}"
    }
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        link,
        layerContent,
        button,
        json
      },
      "partials": {
        "dma-title-module-title": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "dma-title-module-title": renderTemplate
  },
  "helpers": {
    link,
    layerContent,
    button,
    json
  },
  "dependencies": {
    "@sparta.digital-mortgage-application.utilities/mlo-information-utility": "^2.0.0",
    "@sparta.digital-mortgage-application.utilities/workflow-utility": "^2.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.helpers/button-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-store-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/**
 * Main DMA Title module sparta class. This module is used as a childmodule of the
 * global nav module to allow for the help tooltip and dynamic content.
 */
class DMATitleModuleJS extends Module {
  /**
   * Module constructor using sparta options
   * @param {Object} options Sparta options
   * @param {Object} context Sparta context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = this.settings.$target;
  }

  /**
   * Called when the page is loaded, initializes the module.
   * @returns {void}
   */
  init() {
    const {
      copy
    } = this.settings;
    const titleContentTemplate = this.settings.config.partials['dma-title-module-title'];

    /**
     * Workflow lifecycle method - calls after router partials have been run and added to the DOM.
     * @param {$} $module JQuery reference to the module element.
     * @param {Function} dispatch Dispatches an action to the store.
     * @param {Function} getState Gets the state from the store.
     * @returns {void}
     */
    function onMount($module, dispatch, getState) {
      const state = getState();
      const {
        dataReceived
      } = state;
      const {
        primaryApplicantPhone,
        messageCodes,
        mloInformation
      } = dataReceived;
      const {
        nmlsid,
        firstName,
        lastName
      } = mloInformation || {};
      if (state && mloInformation && nmlsid) {
        let {
          phoneNumber
        } = mloInformation;
        phoneNumber = phoneNumber ? `${phoneNumber.slice(0, 3)}.${phoneNumber.slice(3, 6)}.${phoneNumber.slice(6)}` : phoneNumber;
        document.getElementById('dmaTitleModuleContainer').innerHTML = titleContentTemplate({
          mloInformation,
          showMLOInfo: nmlsid && firstName && lastName,
          copy,
          formattedMLOPhone: phoneNumber,
          showGetACallBackLink: mloInformation.isGetACallBackEnabled && primaryApplicantPhone
        });
      } else {
        document.getElementById('dmaTitleModuleContainer').innerHTML = titleContentTemplate({
          mloInformation: {},
          copy
        });
      }
      const subCampPhoneNumber = state.dataReceived.subCampPhoneNumber ? state.dataReceived.subCampPhoneNumber : '800.324.4842';
      const subCampPhoneWithDashes = subCampPhoneNumber.replace(/\./g, '-');

      // Update the phone number in the Help icon modal based off backend response
      $('.title-module-phone').text(subCampPhoneNumber);
      $('.tel-url').attr('href', `tel:${subCampPhoneWithDashes}`);

      /**
       * Closes the "get a callback" modal.
       * @param {Event} event The click event triggering this.
       * @returns {void}
       */
      function removeGetACallBackModal(event) {
        event.stopPropagation();
        spartaUILayersUtility.closeLayer();
        $('#helpCallMeBackModalSpartaUILayer').remove();
      }
      if (primaryApplicantPhone) {
        const $helpCallMeBackModal = $('#helpCallMeBackModal');
        $('#lastFour', $helpCallMeBackModal).text(primaryApplicantPhone.substr(-4));
        requestAnimationFrame(() => {
          $('.call-me-back-link').on('click', () => {
            spartaUILayersUtility.openLayer($helpCallMeBackModal);
            $('#helpCallMeBackModalSpartaUILayerClose').off().on('click', removeGetACallBackModal);
            $('#callMeBackBtn', $helpCallMeBackModal).off().on('click', removeGetACallBackModal);
          });
          $('#callMeBackBtn', $helpCallMeBackModal).off().on('click', removeGetACallBackModal);
        });
      }

      /**
       * Shows MLO modal depending on message codes.
       * @returns {void}
       */
      function maybeShowMloModal() {
        if (messageCodes && messageCodes.indexOf('H039') > -1) {
          const $mloWorksWithAssociateModal = $('#mloWorksWithAssociateModal');
          spartaUILayersUtility.openLayer($mloWorksWithAssociateModal);
          $('#continueAsEmployeeBtn', $mloWorksWithAssociateModal).off().on('click', () => {
            spartaUILayersUtility.closeLayer();
          });
        }
      }
      maybeShowMloModal();
      spartaEventsUtility.sub('DME.maybeShowMloModal', maybeShowMloModal);
      if (messageCodes && messageCodes.indexOf('H040') > -1) {
        if (mloInformation) {
          const {
            email,
            phoneNumber,
            phoneExt
          } = mloInformation;
          const modal = document.querySelector('#mloLendingOfficerChangedModal');
          const modalStringContainer = modal.querySelector('p');
          let modalString = modalStringContainer.innerHTML;
          modalString = modalString.replace('[mloFirstName]', firstName);
          modalString = modalString.replace('[mloLastName]', lastName);
          modalString = modalString.replace('[nmlsNumber]', nmlsid);
          modalString = modalString.replace('[mloEmailAddress]', email);
          const formattedPhoneNumber = phoneNumber ? `${phoneNumber.slice(0, 3)}.${phoneNumber.slice(3, 6)}.${phoneNumber.slice(6)}` : phoneNumber;
          if (phoneExt) {
            modalString = modalString.replace('[mloPhoneNumber]', `${formattedPhoneNumber} Ext. ${phoneExt}`);
          } else {
            modalString = modalString.replace('[mloPhoneNumber]', formattedPhoneNumber);
          }
          modalStringContainer.innerHTML = modalString;
        }
        const $mloLendingOfficerChangedModal = $('#mloLendingOfficerChangedModal');
        spartaUILayersUtility.openLayer($mloLendingOfficerChangedModal);
        // delete html from popup so that it changes when re-opened
        $('#mloLendingOfficerChangedModalSpartaUILayerClose').on('click', () => $('#mloLendingOfficerChangedModalSpartaUILayer').remove());
        $('#continueWithApplicationBtn', $mloLendingOfficerChangedModal).off().on('click', () => {
          spartaUILayersUtility.closeLayer();
          // delete html from popup so that it changes when re-opened
          $('#mloLendingOfficerChangedModalSpartaUILayer').remove();
        });
      }
      if (nmlsid && firstName && lastName) {
        const mloInfoContainer = document.querySelector('#helpIconInsertMloInfo');
        mloInfoContainer.innerHTML = mloInformationUtility.initMlo(dataReceived, copy, true);
      }
    }
    onMount.oncePerRoute = true;
    workflowUtility.dispatch(workflowUtility.actions.initModule(this.$target, {
      onMount
    }));
  }
}
/* istanbul ignore next */

registerModuleClass({
  moduleClass: DMATitleModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { DMATitleModuleJS as default, moduleConfig };
